import React from 'react';
import { Flight } from '@material-ui/icons';
import CancelPolicySection from './cancel_policy_section';
import SameDayCancelRuleTable from './same_day_cancel_rule_table';

const DomesticAirCancelGuide: React.FC = () => (
  <CancelPolicySection
    title="国内航空券のキャンセル依頼期限について"
    icon={<Flight style={{ fontSize: 18, color: '#fff' }} />}
  >
    <SameDayCancelRuleTable />
  </CancelPolicySection>
);

export default DomesticAirCancelGuide;
